export const urlPrefixEN = 'jobs'
export const urlPrefixES = 'trabaja-con-nosotros'
export const urlPrefixPT = 'trabalhe-conosco'

export const urlPrefix = {
  'pt-br': urlPrefixPT,
  es: urlPrefixES,
  en: urlPrefixEN,
}

export const urlToken = {
  positions: {
    'pt-br': 'vagas',
    en: 'positions',
    es: 'ofertas',
  },
  culture: {
    'pt-br': 'cultura',
    en: 'culture',
    es: 'cultura',
  },
  programs: {
    'pt-br': 'programas-de-carreira',
  },
}

export const pages = {
  index: {
    en: `/${urlPrefixEN}`,
    es: `/${urlPrefixES}`,
    'pt-br': `/${urlPrefixPT}`,
  },
  'positions/index': {
    en: `/${urlPrefixEN}/${urlToken.positions.en}`,
    es: `/${urlPrefixES}/${urlToken.positions.es}`,
    'pt-br': `/${urlPrefixPT}/${urlToken.positions[`pt-br`]}`,
  },
  'positions/_id': {
    en: `/${urlPrefixEN}/${urlToken.positions.en}/:id`,
    es: `/${urlPrefixES}/${urlToken.positions.es}/:id`,
    'pt-br': `/${urlPrefixPT}/${urlToken.positions[`pt-br`]}/:id`,
  },
  culture: {
    en: `/${urlPrefixEN}/${urlToken.culture.en}`,
    es: `/${urlPrefixES}/${urlToken.culture.es}`,
    'pt-br': `/${urlPrefixPT}/${urlToken.culture[`pt-br`]}`,
  },
  programs: {
    'pt-br': `/${urlPrefixPT}/${urlToken.programs[`pt-br`]}`,
  },
}

export default pages
